import { useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";

import { Content_SYS1020_R01 } from "./Content_SYS1020_R01";
import { SYS1020_R01Dto } from "./Dto_SYS1020_R01";
import { SearchSection_SYS1020_R01 } from "./SearchSection_SYS1020_R01";
import { useSYS1020_R01Store } from "./Store_SYS1020_R01";
import { Table_SYS1020_R01 } from "./Table_SYS1020_R01";

export const Container_SYS1020_R01 = () => {
    const { SYS1020_R01List } = useSYS1020_R01Store();
    const { setMessage } = useUiuxStore();
    const gridRef = useRef<AgGridReact<SYS1020_R01Dto>>(null);

    const {
        clickable,
        setClickable,
        fetchData,
        handleInsertClick,
        handleDeleteClick,
        handleSaveClick,
        handleExcelClick,
        initContainerData,
        defaultSYS1020_R01Row,
    } = Content_SYS1020_R01({ gridRef, setMessage });

    useEffect(() => {
        if (SYS1020_R01List.length === 0) {
            handleInsertClick({} as React.MouseEvent<HTMLButtonElement>);
        }
    }, [SYS1020_R01List.length, handleInsertClick]);

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={handleInsertClick}
                onDeleteClick={handleDeleteClick}
                onSaveClick={handleSaveClick}
                onExcelClick={handleExcelClick}
                onInitClick={initContainerData}
            />
            <SearchSection_SYS1020_R01 />
            <div className="flex-1 flex">
                <div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
                    <Table_SYS1020_R01
                        clickable={clickable}
                        setClickable={setClickable}
                        gridRef={gridRef}
                        defaultSYS1020_R01Row={defaultSYS1020_R01Row()}
                        handleInsertClick={handleInsertClick}
                    />
                </div>
            </div>
            <Message />
        </div>
    );
};
